import Components from "slotworks/components/components";
import { parallel } from "slotworks/utils/race-utils";
import Contract from "slotworks/utils/contract";
import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import * as TweenJS from "slotworks/utils/tween";
import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import graphicsManager from "slotworks/graphics/graphics-manager";
import Layers from "slotworks/graphics/layers/layers";
import soundManager from "slotworks/sound/sound-manager";
import DSComponents from "components/components";

const SCALE: number = 1.3;
const DURATION: number = 150;

export default class ScatterWinComponent {

    private animate(symbol:SymbolComponent) :Contract<void> {
        return new Contract(resolve => {
            const pot:AnimatedSprite = graphicsManager.createAnimation('POT_land');
            const matrixSymbolTransform = symbol.getTransform();
            const transform = Layers.MatrixContent.localToLocal(Layers.SymbolAnimations, matrixSymbolTransform);
            pot.anchor.set(0.5, 0.5);
            pot.setTransform(transform.x + matrixSymbolTransform.width/2, transform.y + matrixSymbolTransform.height/2);            
            Layers.SymbolAnimations.add(pot);
            new TweenJS.Tween(pot.scale) 
            .to({x: SCALE, y: SCALE}, DURATION)
            .onComplete(() => {
                // emitter
                const front = Layers.MatrixContent.localToLocal(Layers.MatrixForeground, matrixSymbolTransform);
                setTimeout( () =>
                DSComponents.potLandEmitter.potLandEmit(symbol.gridPosition.x, front.x + matrixSymbolTransform.width/2, front.y), 150);
                pot.loop = false;
                pot.onComplete = () => {
                    setTimeout(() => { pot.parent.removeChild(pot); pot.destroy(); }, 2000);
                    resolve(null);
                };
                pot.play();                
            }).start();
        });
    }

    public start() :Contract<void> {
        return new Contract(resolve => {        
            const reels = Components.matrix.getReels();

            const tweenFunctions = [];
            for (let reel of reels) {
                const symbols = reel.getSymbols();
                for (let symbol of symbols) 
                    if(symbol.symbolId === "POT") {
                        tweenFunctions.push(() => this.animate(symbol));
                }
            }
            soundManager.customEvent("progressive_pot_land_3");
            parallel(tweenFunctions).then(() => {
                resolve(null);
            });
        });
    }
}